import { ref } from 'vue';
import { useNotifications } from './use-notifications';
import { getErrorMessage as getErrorMessageUtil } from '@/modules/core/utilities';
import axios from 'axios';
import errorMessages from '../error-messages';

const isActionInProgress = ref(false);
const { showToast } = useNotifications();

export async function useErrorHandling<T> (
    promise: Promise<T> | ((...args: any[]) => Promise<T>),
    getErrorMessage = getErrorMessageUtil
) {
    try {
        isActionInProgress.value = true;
        if (typeof promise === 'function') return await promise();
        return await promise;
    } catch (error: any) {
        let errorMessage = getErrorMessage(error);
        const suppressToast = axios.isAxiosError(error) && error.config?.suppressAuthCheckRedirect;
        if (!suppressToast && errorMessage !== 'Email not registered') {
            showToast({ message: errorMessage, type: 'danger' })
        }
        else {
            showToast({
                message: errorMessages.EMAIL_NOT_REGISTERED,
                type: 'danger',
            })
        }
        throw error;
    } finally {
        isActionInProgress.value = false;
    }
}